<template>
  <div>
    <template v-if="debug">
      <pre>wizard validator {{step}}</pre>
      <pre>{{allFieldsFilled}}</pre>
      <button class="btn btn-sm" @click.prevent="setOn">ON</button>
      <button class="btn btn-sm" @click.prevent="setOff">OFF</button>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    step: {
      type: [Number],
      required: true
    },
  },

  data() {
    return {
      debug: false,
      isValid: false,
      $form: null,
      allFieldsFilled: false,
    };
  },

  mounted() {
    this.$form = $(`[data-step=${this.step}] [data-validation]`);

    switch(Number(this.step)) {
      case 2:
        this.$form.on('click', this.handleChaneOnClick);
        break;
      case 4:
        this.$form.on('change', this.handleChange);
        this.$form.on('input', this.handleChange);

        this.recalculateError();
        break;
      default:
        break;
    }
  },

  beforeDestroy() {
    if (this.$form) {
      this.$form.off('change');
      this.$form.off('input');
      this.$form.off('click');
    }
  },

  watch: {
    allFieldsFilled(newValue) {
      this.isValid = newValue;
      this.toggleStep();
    }
  },

  methods: {
    handleChange(event) {
      const target = event.target;
      const tag = target.tagName;
      const type = target.type;

      let result = false;

      if (
        tag === 'INPUT' &&
        ['text', 'email', 'tel', 'password', 'number', 'search', 'url', 'hidden'].includes(type)
      ) {
        // Return true if there is some value (not just whitespace)
        result = target.value.trim().length > 0;
      } else if (tag === 'TEXTAREA') {
        // Return true if there is some value (not just whitespace)
        result = target.value.trim().length > 0;
      } else if (tag === 'INPUT' && type === 'checkbox') {
        // Return true if checked
        result = target.checked;
      } else if (tag === 'INPUT' && type === 'radio') {
        // Return true if any radio with the same name is checked
        const form = target.form || document;
        const radios = form.querySelectorAll(`input[type="radio"][name="${target.name}"]`);
        result = Array.from(radios).some(radio => radio.checked);
      } else if (tag === 'SELECT') {
        // Return true if something is selected (not empty string)
        result = target.value !== '';
      }

      this.toggleVisibleError(target, result)
        .then(() => {
          this.recalculateError();
        })

      return result;
    },

    handleChaneOnClick(e) {
      const target = e.currentTarget;
      const field = target.querySelector('input[type="hidden"]');
      let result = true;

      if (field) {
        result = !!field.value;
      }

      this.toggleVisibleError(field, result)
        .then(() => {
          this.recalculateError();
        })

      return result;
    },

    toggleVisibleError(field, isValid) {
      return new Promise(resolve => {
        const $error = field.closest('.form-field, .partner-select').querySelector('.field-error');

        if ($error) {
          $error.classList.toggle('d-none', isValid);
        }

        resolve(isValid);
      })
    },

    recalculateError() {
      switch (Number(this.step)) {
        case 2:
          this.allFieldsFilled = !!this.$form.find('input[type="hidden"]').val();
          break;
        case 4:
          const $errors = this.$form ? this.$form.find('.field-error') : [];
          const $visibleErrors = Array.from($errors).filter(error => !error.classList.contains('d-none'));
          const $allRequiredFields = this.$form ? this.$form.find('[required]') : [];
          const $filledFields = Array.from($allRequiredFields).filter(field => {
            const tag = field.tagName;
            const type = field.type;

            if (tag === 'INPUT' && ['text', 'email', 'tel', 'password', 'number', 'search', 'url'].includes(type)) {
              return field.value.trim().length > 0;
            } else if (tag === 'INPUT' && type === 'checkbox') {
              return field.checked;
            } else if (tag === 'INPUT' && type === 'radio') {
              const radios = this.$form.querySelectorAll(`input[type="radio"][name="${field.name}"]`);
              return Array.from(radios).some(radio => radio.checked);
            } else if (tag === 'TEXTAREA') {
              return field.value.trim().length > 0;
            } else if (tag === 'SELECT') {
              return field.value !== '';
            }

            return false;
          });

          this.allFieldsFilled = $filledFields.length === $allRequiredFields.length && !$visibleErrors.length;
          break;
        default:
          break;
      }
    },

    setOn() {
      this.isValid = true;
      this.toggleStep();
    },

    setOff() {
      this.isValid = false;
      this.toggleStep();
    },

    toggleStep() {
      this.$eventBus.$emit('wizard_step:toggle', Number(this.step), this.isValid);
    }
  }
}
</script>
